const BUG_ASSIGNMENT_PROMPT_KEY = "showBugAssignmentsAfterLogin";

export const markBugAssignmentPromptForLogin = () => {
  sessionStorage.setItem(BUG_ASSIGNMENT_PROMPT_KEY, "true");
};

export const consumeBugAssignmentPrompt = () => {
  const shouldShow =
    sessionStorage.getItem(BUG_ASSIGNMENT_PROMPT_KEY) === "true";
  sessionStorage.removeItem(BUG_ASSIGNMENT_PROMPT_KEY);
  return shouldShow;
};
